import React from "react";
import { Check } from "lucide-react";
import styles from "../../../_css/AddRoleplay.module.css"

const steps = [
    "Define the roles",
    "Describe Your Scenario",
    "Avatar Behaviour & Difficulty level",
    "Learning Goals & Competencies",
    "Upload Documents",
    "Preview & Start",
];

const StepperVertical = ({ currentStep = 0, completedSteps = [], onStepClick }) => {
    const isStep1Completed = completedSteps.includes(1);

    return (
        <div className={styles.stepperContainer}>
            {steps.map((label, index) => {
                const stepNum = index + 1;
                const isActive = currentStep === stepNum;
                const isCompleted = completedSteps.includes(stepNum);

                // Determine clickable state
                const isClickable = isStep1Completed || isCompleted || stepNum <= currentStep;

                return (
                    <div
                        key={index}
                        // Combine module classes
                        className={`${styles.stepItem} ${isClickable ? styles.clickable : ""}`}
                        onClick={() => isClickable && onStepClick && onStepClick(stepNum)}
                    >
                        <div className={styles.stepIconWrapper}>
                            <div
                                className={`
                                    ${styles.stepCircle} 
                                    ${isActive ? styles.active : ""} 
                                    ${isCompleted ? styles.completed : ""}
                                `}
                            >
                                {isCompleted ? (
                                    <Check size={18} color="#FFFFFF" />
                                ) : (
                                    <span>
                                        {stepNum}
                                    </span>
                                )}
                            </div>

                            {stepNum !== steps.length && (
                                <div
                                    className={`${styles.stepLine} ${isCompleted ? styles.completed : ""}`}
                                />
                            )}
                        </div>

                        <div
                            className={`
                                ${styles.stepLabel} 
                                ${isActive ? styles.active : ""} 
                                ${isCompleted ? styles.completed : ""}
                                ${isClickable ? styles.clickable : ""}
                            `}
                        >
                            {label}
                        </div>
                    </div>
                );
            })}
        </div>
    );
};

export default StepperVertical;